import * as React from 'react';
import { Tooltip } from 'antd';
import './index.css';
export default function PlateBuyer(props) {
    var buyerData = props.buyerData, _a = props.buyerTitle, buyerTitle = _a === void 0 ? {} : _a;
    return (React.createElement("div", { className: 'plate_buyer_box' },
        React.createElement("div", { className: 'plate_buyer_name' }, "\u8D2D\u4E70\u65B9"),
        React.createElement("div", { className: 'plate_buyer_title_text_box' },
            React.createElement("div", { className: 'plate_buyer_title_text' }, buyerTitle.nameTitle || '购买方名称'),
            React.createElement("div", { className: 'plate_buyer_title_text' }, buyerTitle.taxNumberTitle || '购买方纳税人识别号'),
            React.createElement("div", { className: 'plate_buyer_title_text' }, buyerTitle.addressAndPhoneTitle || '购买方地址及电话'),
            React.createElement("div", { className: 'plate_buyer_title_text' }, buyerTitle.bankAddressAndNumberTitle || '购买方开户行及账号')),
        React.createElement("div", { className: 'plate_buyer_title_content_box' },
            React.createElement("div", { className: 'plate_buyer_title_content' }, buyerData.name),
            React.createElement("div", { className: 'plate_buyer_title_content' }, buyerData.taxNumber),
            React.createElement("div", { className: 'plate_buyer_title_content' },
                React.createElement(Tooltip, { title: buyerData.addressAndPhone }, buyerData.addressAndPhone)),
            React.createElement("div", { className: 'plate_buyer_title_content' },
                React.createElement(Tooltip, { title: buyerData.bankAddressAndNumber }, buyerData.bankAddressAndNumber))),
        React.createElement("div", { className: 'plate_buyer_name' }, buyerTitle.passwordTitle || '密码区'),
        React.createElement("div", { className: 'plate_pwd' }, buyerData.password)));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-invoice-plate/InvoicePlate/PlateBuyer/index.js
// module id = 4160
// module chunks = 0